<template>
	<div>
		<analytics-el-text
			v-if="post.type.S === 'text'"
			:text="_getSafeStr(post.text)"
			:isFullView="isFullView"
		/>

		<analytics-el-img
			v-if="post.type.S === 'image'"
			:SM="SM"
			:src="post.image.S"
			:post="post"
			:isFullView="isFullView"
			:bypassPreFetch="bypassPreFetch"
			:preFetchImages="preFetchImages"
		/>

		<analytics-el-img
			v-if="post.type.S === 'gif'"
			:SM="SM"
			:src="post.gif.S"
			:post="post"
			:isFullView="isFullView"
			:bypassPreFetch="bypassPreFetch"
			:preFetchImages="preFetchImages"
		/>

		<analytics-el-video
			v-if="post.type.S === 'video'"
			:src="_getSafeStr(post.video)"
			:isFullView="isFullView"
		/>

		<analytics-el-audio
			v-if="post.type.S === 'audio'"
			:src="post.audio.S"
			:type="post.mimeType"
			:autoplay="false"
		/>

		<analytics-el-youtube
			v-if="
				post.type.S === 'link' && post.linkType && post.linkType.S === 'youtube'
			"
			:src="post.linkProperty.S"
			:autoplay="false"
		/>

		<analytics-el-news-link
			v-if="post.type.S === 'link' && post.image && !post.linkType"
			:SM="SM"
			:src="post.image.S"
			:linkDesc="post.linkDescription ? post.linkDescription.S : ''"
			:post="post"
			:isFullView="isFullView"
			:bypassPreFetch="bypassPreFetch"
			:preFetchImages="preFetchImages"
		/>
	</div>
</template>

<script>
import AnalyticsElImg from "./img";
import AnalyticsElText from "./text";
import AnalyticsElVideo from "./video";
import AnalyticsElAudio from "./audio";
import AnalyticsElNewsLink from "./news-link";
import AnalyticsElYoutube from "./youtube";

import * as utils from "@/utils.js";

export default {
	name: "AnalyticsElGraphics",
	props: ["SM", "post", "isFullView", "bypassPreFetch", "preFetchImages"],
	components: {
		"analytics-el-img": AnalyticsElImg,
		"analytics-el-text": AnalyticsElText,
		"analytics-el-video": AnalyticsElVideo,
		"analytics-el-audio": AnalyticsElAudio,
		"analytics-el-news-link": AnalyticsElNewsLink,
		"analytics-el-youtube": AnalyticsElYoutube
	},
	methods: {
		_getSafeStr(obj) {
			return utils._getSafeStr(obj);
		}
	}
};
</script>
